import { render, staticRenderFns } from "./EventsNotification.vue?vue&type=template&id=e2175e66&"
import script from "./EventsNotification.vue?vue&type=script&lang=js&"
export * from "./EventsNotification.vue?vue&type=script&lang=js&"
import style0 from "./EventsNotification.vue?vue&type=style&index=0&id=e2175e66&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports